export default {
    SaveProfileDetail : 'SaveProfileDetail',
    SaveProfileCity : 'SaveProfileCity',
    SavePicture : 'SavePicture',
    ChangeMainPicture : 'ChangeMainPicture',
    NewLocation : 'NewLocation',
    DeleteUserPicture : 'DeleteUserPicture',
}
